import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitBuggy = (data) => axios.post(`${API}/forms/buggy`, data);
export const submitLesson = (data) => axios.post(`${API}/forms/lessons`, data);
export const submitEvent = (data) => axios.post(`${API}/forms/events`, data);
export const submitPartner = (data) => axios.post(`${API}/forms/partner`, data);
